import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "blocked-cards-tooltip" }
const _hoisted_2 = { class: "font-medium" }

import { computed } from 'vue';
import CardStatusAndTitle from '@/components/tooltips/CardStatusAndTitle.vue';
import useTranslate from '@/utilities/composables/useTranslate';


export default /*@__PURE__*/_defineComponent({
  __name: 'RelatedCardsTooltip',
  props: {
  cards: {
    type: Array,
    required: true,
  },
  relationType: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const { translate } = useTranslate();

const props = __props;

const label = computed(() => {
  let relationLabel = '';
  switch (props.relationType) {
    case 'blocked_by':
      relationLabel = translate('blockedBy');
      break;
    case 'blocks':
      relationLabel = translate('blocks');
      break;
    default:
      break;
  }
  return `${relationLabel} ${props.cards.length} ${
    props.cards.length > 1 ? translate('cards').toLowerCase() : translate('card').toLowerCase()
  }`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(label.value), 1),
    _cache[0] || (_cache[0] = _createTextVNode()),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cards, (blockedCard, index) => {
      return (_openBlock(), _createBlock(CardStatusAndTitle, {
        key: index,
        title: blockedCard.title,
        "card-id": blockedCard.card_id,
        status: blockedCard.status || ''
      }, null, 8, ["title", "card-id", "status"]))
    }), 128))
  ]))
}
}

})